/* eslint-disable react/jsx-filename-extension */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  LinearProgress,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { Close, CheckCircle, Error, HourglassEmpty } from '@material-ui/icons';
import { getImportJob } from 'src/services/admin/biometrics';

const ImportProgressMonitor = ({ open, onClose, jobId, conjuntoId }) => {
  const [jobData, setJobData] = useState(null);

  useEffect(() => {
    if (!open || !jobId || !conjuntoId) return () => {};

    const unsubscribe = getImportJob(conjuntoId, jobId, (snapshot) => {
      if (snapshot.exists) {
        setJobData({ id: snapshot.id, ...snapshot.data() });
      }
    });

    return () => unsubscribe();
  }, [open, jobId, conjuntoId]);

  if (!jobData) return null;

  const progress = jobData.total_rostros > 0 
    ? (jobData.procesados / jobData.total_rostros) * 100 
    : 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Progreso de Importación</Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box mb={3}>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography variant="body2">
              {jobData.procesados} / {jobData.total_rostros} rostros procesados
            </Typography>
            <Typography variant="body2" style={{ fontWeight: 'bold' }}>
              {Math.round(progress)}%
            </Typography>
          </Box>
          <LinearProgress 
            variant="determinate" 
            value={progress} 
            style={{ height: 8, borderRadius: 4 }}
          />
        </Box>

        <Box display="flex" gap={2} mb={3}>
          <Paper style={{ padding: 12, flex: 1, textAlign: 'center', backgroundColor: '#e8f5e8' }}>
            <Typography variant="h5" style={{ color: '#4caf50' }}>
              {jobData.exitosos || 0}
            </Typography>
            <Typography variant="caption">Exitosos</Typography>
          </Paper>
          <Paper style={{ padding: 12, flex: 1, textAlign: 'center', backgroundColor: '#ffebee' }}>
            <Typography variant="h5" style={{ color: '#f44336' }}>
              {jobData.fallidos || 0}
            </Typography>
            <Typography variant="caption">Fallidos</Typography>
          </Paper>
          <Paper style={{ padding: 12, flex: 1, textAlign: 'center', backgroundColor: '#fff3e0' }}>
            <Typography variant="h5" style={{ color: '#ff9800' }}>
              {jobData.total_rostros - jobData.procesados}
            </Typography>
            <Typography variant="caption">Pendientes</Typography>
          </Paper>
        </Box>

        <Box mb={2}>
          <Chip
            icon={
              jobData.status === 'completed' ? <CheckCircle /> :
              jobData.status === 'failed' ? <Error /> :
              <HourglassEmpty />
            }
            label={
              jobData.status === 'processing' ? 'Procesando...' :
              jobData.status === 'completed' ? 'Completado' :
              jobData.status === 'failed' ? 'Fallido' :
              'Pendiente'
            }
            color={
              jobData.status === 'completed' ? 'primary' :
              jobData.status === 'failed' ? 'secondary' :
              'default'
            }
          />
        </Box>

        {jobData.rostros && jobData.rostros.length > 0 && (
          <TableContainer component={Paper} style={{ maxHeight: 400 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Estado</TableCell>
                  <TableCell>Identificación</TableCell>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Mensaje</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {jobData.rostros.map((rostro, index) => (
                  <TableRow 
                    key={`rostro-progress-${rostro.identificacion}-${index}`}
                    style={{
                      backgroundColor: 
                        rostro.status === 'completed' ? '#f1f8e9' :
                        rostro.status === 'failed' ? '#ffebee' :
                        '#fff3e0'
                    }}
                  >
                    <TableCell>
                      <Chip
                        size="small"
                        label={
                          rostro.status === 'completed' ? 'Exitoso' :
                          rostro.status === 'failed' ? 'Fallido' :
                          'Procesando'
                        }
                        icon={
                          rostro.status === 'completed' ? <CheckCircle /> :
                          rostro.status === 'failed' ? <Error /> :
                          <HourglassEmpty />
                        }
                      />
                    </TableCell>
                    <TableCell>{rostro.identificacion}</TableCell>
                    <TableCell>{rostro.nombre}</TableCell>
                    <TableCell>
                      <Typography variant="caption" color={rostro.status === 'failed' ? 'error' : 'textSecondary'}>
                        {rostro.error || 'OK'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImportProgressMonitor;